module.exports = __webpack_public_path__ + "static/media/dashboard.ade92e8d.png";